import i18next from 'i18next';
const lang = {
    addition_logo: "img/games/addition/logo.png",
    addition_button_first_game: "Single Player",
    addition_button_second_game: "Two Players",
    addition_button_settings: "Settings",
    addition_button_save: "Save",
    addition_button_back: "Back",
    addition_title_first_number: "1st Number",
    addition_title_second_number: "2nd Number",
    addition_title_number_description: "Number of Digits",
    addition_description_first_multiplier: "1st Player",
    addition_description_second_multiplier: "2nd Player",
    addition_description_gamer: "Player {{gamer}}",
    addition_title_time: "Time",
    addition_title_second: "Seconds",
    addition_title_point: "Points",
    addition_title_record: "Record",
    addition_title_winning: "Winner",
    addition_description_record: "Congratulations, you have a new record.",
    addition_description_landscape: "Please use your device in landscape mode!",
    addition_result_draw: "Draw",
    addition_info_wait: "Stay calm for {{time}} seconds",
    addition_info_continue: "You can continue solving",
    addition_info_error: "You made a mistake",
    addition_info_notification_1: "Congratulations",
    addition_info_notification_2: "You're doing great",
    addition_info_notification_3: "Awesome",
    addition_info_notification_4: "Superb"
}



// i18next.addResourceBundle('en', 'translation', lang, true, true);
export default lang;
